
import React from 'react';
import './Button.css';

const Button = ({
    children,
    onClick,
    variant = 'primary',
    type = 'button',
    fullWidth = false,
    disabled = false,
    className = ''
}) => {
    return (
        <button
            type={type}
            className={`btn btn-${variant} ${fullWidth ? 'btn-full' : ''} ${className}`}
            onClick={onClick}
            disabled={disabled}
        >
            {children}
        </button>
    );
};

export default Button;
